import { useState } from "react";
import { useDispatch } from "react-redux";
import useFetch from "../../../hook/useFetch";
import { notificationActions } from "../../../store/notification-slice";
import { useConfirmation } from "../../AppModal";

export default function RefundRequestButton({ order }) {
  const [requestStatus, setRequestStatus] = useState(order.refund_request_status);
  const [submitting, setSubmitting] = useState(false);
  const { update } = useFetch();
  const dispatch = useDispatch();
  const confirm = useConfirmation();

  if (order.payment_provider !== "paypal" || order.payment_status !== "completed") {
    return null;
  }

  if (requestStatus === "pending") {
    return <span className="badge bg-warning text-dark">Refund requested</span>;
  }

  if (requestStatus === "rejected") {
    return <span className="badge bg-secondary">Refund rejected – order remains active</span>;
  }

  return (
    <button
      type="button"
      className="btn btn-outline-danger btn-sm"
      disabled={submitting}
      onClick={async (event) => {
        event.stopPropagation();
        if (!await confirm("Rückerstattung für diese PayPal-Zahlung anfordern? Alle Bestellungen derselben Zahlung sind enthalten.", "Rückerstattung anfordern")) {
          return;
        }

        setSubmitting(true);
        update(
          "/payment/rollback-request",
          { order_id: order.id },
          (error) => {
            setSubmitting(false);
            dispatch(notificationActions.setNotification({ message: error, status: false }));
          },
          (payment) => {
            setSubmitting(false);
            setRequestStatus(payment.refund_request_status);
            dispatch(notificationActions.setNotification({
              message: "Refund request sent to the administrator.",
              status: true,
            }));
          },
        );
      }}
    >
      {submitting ? "Sending..." : "Request refund"}
    </button>
  );
}
